import settings from '@/settings'

export const API_REQUEST_TIMEOUT = 30000

const READY = 1

/**
 * Init Shared Session Widget
 */
export function initSessionWidget () {
  window.SESSIONWIDGET_DOMAIN = `https://${settings.SSW_HOST}`
  window.SESSIONWIDGET_INIT_FRAME = true

  const script = document.createElement('script')
  script.src = `//${settings.SSW_HOST}/id/static/latest/sessionwidget/js/ssw.min.js`

  document.body.appendChild(script)
}

/**
 * @param {String} clientId
 * @returns {Promise.<SessionWidgetSDK>}
 */
export function createSessionWidget (clientId) {
  return new Promise((resolve, reject) => {
    if (window.SessionWidgetSDK) {
      const sessionWidget = new window.SessionWidgetSDK(clientId)
      if (sessionWidget.state() === READY) {
        return resolve(sessionWidget)
      }

      const timeOut = setTimeout(() =>
        reject(new Error('SessionWidget connection timeout')), API_REQUEST_TIMEOUT)

      sessionWidget.onready(() => {
        clearTimeout(timeOut)
        resolve(sessionWidget)
      })
    }

    setTimeout(() => resolve(createSessionWidget(clientId)), 100)
  })
}
